import React, { useState } from "react";
import "./Signup.scss";
import { Link, useHistory } from "react-router-dom";
import { motion } from "framer-motion";
import { errorAnim } from "../utils/styleUtils";
import { useQuery } from "../utils/scrollToTop";
import { auth } from "../utils/firebase";
import { useStateValue } from "../context/StateProvider";

function PasswordReset() {
  const [errorEmail, setErrorEmail] = useState(false);
  const [email, setEmail] = useState("");
  const [formError, setFormError] = useState("");
  const [status, setStatus] = useState(false);
  const [success, setSuccess] = useState(false);

  const validateEmail = (value) => {
    const re = /\S+@\S+\.\S+/;
    return re.test(value);
  };

  const sendResetLink = async (email) => {
    auth
      .sendPasswordResetEmail(email)
      .then((response) => {
        console.log(response);
        setEmail("");
        setFormError("Check your mail for the password reset link.");
        setStatus(false);
        // loadingBar.current.complete();
        setSuccess(true);
      })
      .catch((error) => {
        setFormError(error.message);
        setStatus(false);
        // loadingBar.current.complete();
        setSuccess(false);
      });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!email || !validateEmail(email)) {
      setErrorEmail(true);
    } else {
      setStatus(true);
      //   loadingBar.current.continuousStart();
      sendResetLink(email);
    }
  };

  return (
    <div className="passwordReset">
      <form className="form" onSubmit={(e) => handleSubmit(e)}>
        <h4>Recover your Password</h4>
        {formError && (
          <motion.p
            initial="initial"
            animate="in"
            exit="out"
            variants={errorAnim}
            class={`form__error error ${success ? "green" : ""}`}
          >
            {formError}
          </motion.p>
        )}
        <div className="form__element">
          <input
            className={`${email ? "active " : ""} ${
              errorEmail ? "error " : ""
            }`}
            id="email"
            type="text"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            onFocus={() => setErrorEmail(false)}
          />
          <label for="email">Email Address</label>
          {errorEmail && (
            <motion.p
              initial="initial"
              animate="in"
              exit="out"
              variants={errorAnim}
              className="error"
            >
              Please check your email address
            </motion.p>
          )}
        </div>
        <div className="form__element buttons">
          <button
            disabled={status}
            className="button buttonPrimary submit"
            type="submit"
          >
            {status ? "Verifying..." : "Reset Password"}
          </button>
        </div>
        <hr />
        <Link to="/login">
          <div className="form__element buttons">
            <button className="button buttonSecondary signup">Log In</button>
          </div>
        </Link>
      </form>
    </div>
  );
}
export default PasswordReset;
